import { Injectable } from '@angular/core';
import { GatewayService } from './gateway.service';
import { Observable } from "rxjs/Observable";
import { ProcesoFirma, ResponseProcesoFirma } from '../interfaces/datos-firma-interface';
import { DatosProcesarFirma } from '../Models/Proceso-Firma-Datos.models';

const VERSIONAPI: string = "api-version=1.0";

@Injectable({
  providedIn: 'root'
})
export class FirmaDigitalService {  

  constructor(private gatewayServices: GatewayService) { }

  public obtenerDocumentoPorIdentificador(id: string): Observable<ProcesoFirma> {
    return this.gatewayServices.get<ProcesoFirma>("ProcesoFirma/Obtener?identificador=" + id + "&" + VERSIONAPI);
  }

  public rechazarDocumento(proceso: DatosProcesarFirma): Observable<ResponseProcesoFirma> {
    return this.gatewayServices.post<ResponseProcesoFirma>("ProcesoFirma/Cancelar?" + VERSIONAPI, proceso);   
  }

  public firmarDocumento(proceso: DatosProcesarFirma): Observable<ResponseProcesoFirma> {
    return this.gatewayServices.post<ResponseProcesoFirma>("ProcesoFirma/Firmar?" + VERSIONAPI, proceso);   
  }
}
